import { Tactic } from "@/redux/tactics/tacticsSlice";

import axios from "../../privateApi";

export const uploadTactic = async (tactic: {
  name: string;
  description: string;
  eaCode: string;
}) => {
  const response = await axios.post<Tactic>("/tactics?v=2", tactic);
  return response.data;
};
